import { styled } from '@mui/material';

export const Styles = {
  Main: styled('div')(({ theme }) => ({
    backgroundColor: '#ebebeb',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px 0',
    [theme.breakpoints.down('md')]: {
      padding: '10px 0'
    }
  })),

  Container: styled('div')(({ theme }) => ({
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto',
    backgroundColor: '#FFFFFF',
    border: '2px solid black',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    padding: '20px',
    display: 'flex',
    gap: '20px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '20px',
      padding: '15px',
      border: '1px solid black'
    }
  })),

  Divider: styled('div')(({ theme }) => ({
    width: '3px',
    height: '600px',
    marginRight: '-10px',
    marginTop: '10px',
    backgroundColor: '#04682E',
    borderRadius: '10px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '2px',
      margin: '20px 0'
    }
  })),

  BotSide: styled('div')(({ theme }) => ({
    margin: '0 auto',
    display: 'flex',
    paddingTop: '20px',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '30px',
      alignItems: 'center'
    }
  })),

  MapContainer: styled('div')(({ theme }) => ({
    width: '300px',
    height: '130px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    overflow: 'hidden',
    border: '1px solid rgb(0, 0, 0)',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '100%'
    }
  })),
  Label: styled('label')({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '17px',
    lineHeight: '27px',
    color: '#212529',
    '&.required::after': {
      content: '"*"',
      color: '#FF0000',
      margin: '5px'
    }
  }),
  InfoContainer: styled('div')(({ theme }) => ({
    flex: 1,
    display: 'flex',
    paddingTop: '50px',
    flexDirection: 'column',
    gap: '20px',
    paddingLeft: '25px',
    paddingRight: '20px',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  })),

  // TopLogo: styled('div')({
  //   margin: '0 auto'
  // }),

  Logo: styled('img')({
    height: '145px',
    width: '397px'
  }),

  ContactInfo: styled('div')({
    display: 'flex',
    flexDirection: 'column'
  }),
  ContactBox: styled('div')({
    display: 'flex',
    alignItems: 'flex-start',
    maxHeight: '45px',
    marginLeft: '15px'
  }),
  IconImg: styled('img')({
    width: '30px',
    height: '30px'
  }),
  Text: styled('p')({
    color: 'black',
    paddingLeft: '5px',
    fontSize: '15px',
    marginTop: '-1px',
    display: 'flex',
    alignItems: 'flex-start'
  }),
  LabelTipo: styled('div')(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '24px',
    color: 'black',
    marginBottom: '20px',
    paddingRight: '430px',
    [theme.breakpoints.down('md')]: {
      paddingRight: '0',
      fontSize: '18px',
      textAlign: 'center',
      width: '100%',
      padding: '0 15px',
      marginTop: '20px'
    }
  })),

  FormContainer: styled('div')(({ theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    [theme.breakpoints.down('md')]: {
      gap: '10px',
      width: '100%',
      padding: '0 10px'
    }
  })),

  InputContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    [theme.breakpoints.down('md')]: {
      marginBottom: '8px'
    }
  })),

  Input: styled('input')(({ theme }) => ({
    width: '100%',
    padding: '10px',
    fontSize: '16px',
    border: '1px solid black',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    '&:focus': {
      outline: 'none',
      borderColor: 'black'
    },
    [theme.breakpoints.down('md')]: {
      padding: '8px',
      fontSize: '14px'
    }
  })),

  TextArea: styled('textarea')(({ theme }) => ({
    width: '100%',
    padding: '10px',
    fontSize: '16px',
    border: '1px solid black',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    resize: 'vertical',
    minHeight: '121px',
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E'
    },
    [theme.breakpoints.down('md')]: {
      minHeight: '100px',
      fontSize: '14px'
    }
  })),

  RequiredText: styled('p')(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '17px',
    marginBottom: '0px',
    lineHeight: '27px',
    color: '#212529',
    marginTop: '10px',
    '&::before': {
      content: '"*"',
      color: '#FF0000',
      marginRight: '5px'
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '15px',
      marginTop: '5px'
    }
  })),

  Button: styled('button')(({ theme }) => ({
    width: '35%',
    marginLeft: '130px',
    padding: '10px 30px',
    fontSize: '16px',
    backgroundColor: '#125dae',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#0B327A'
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginLeft: '0',
      fontSize: '14px',
      padding: '12px 20px',
      marginTop: '10px'
    }
  }))
};
